<template>
    <select name="id_language" id="id_language" aria-label="Choose Language" v-on:change="$emit('language_drop', $event.target.value,$event.target.options[$event.target.options.selectedIndex].lang)" aria-required="true">
        <option value="">Choose Language</option>
        <template v-for="(lang,ky) in language_arr">
        <option :lang="lang['language_abbreviation']" :value="lang['id_country_id_language']" :key="ky" :aria-label="lang['country_english'] + lang['language_native'] +' '+ (ky+2) + ' of ' + (language_arr.length + 1)">{{lang['country_english']+'-'+ lang['language_native']}}</option>
        </template>
    </select>
</template>

<script>
import axios from 'axios';
export default {
    name: 'LanguageDropdown',
    data(){
        return{
            language_arr:[]
            //language_drop:''
        };
        
    },
    
    components:{
            
    },
    mounted :function(){
        this.showLanguageDropdown()
    },
    created:function(){
           // console.log(this.centers_block);
    },
	methods:{
        showLanguageDropdown(){       
            //alert('on show language')
            var api_private_key=this.get_api_key_mix('cost')   
            axios.get(this.$store.state.apiUrl+'/company_language_list',{
              params:{
                  id_company:this.$store.state.companyData['id_company'],
                  privatekey:api_private_key     
              }
          })
          .then(response => {
              response = response.data
              this.language_arr = response
             
                            
          })
          .catch(() => {
              this.language_arr = [];
          });
      }

    }
};
</script>
<style scoped>

</style>